import { ErrorMessage, Form, Formik } from "formik";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { passwordValidationSchema } from "../../validationSchema/ValidationSchema";
import Button from "../../components/Button";
import Lable from "../../components/Lable";
import PasswordInput from "../../components/PasswordInput";
import { useSelector } from "react-redux";
import LoaderContext from "../../components/loader";
import AuthApi from "../../apis/auth.apis";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";
import TextInput from "../../components/TextInput";

const ChangePassword = ({ onClose }) => {
  const { handleLoading } = useContext(LoaderContext);
  const { loading, currentUser } = useSelector((state) => state.store);

  console.log("change pwd page");

  const navigate = useNavigate();
  const location = useLocation();
  const { email, phone_number, emailOrPhone } = location.state || {};
  console.log("state passed:", location.state);

  const userEmailOrPhone =
    email || phone_number ||
    (typeof emailOrPhone === "string" ? emailOrPhone : emailOrPhone?.emailOrPhone) ||
    currentUser?.email ||
    currentUser?.phone_number ||
    "";

  useEffect(() => {
    handleLoading(loading);
  }, [handleLoading, loading]);

  const initialValues = {
    emailOrPhone: userEmailOrPhone,
    password: "",
    confirmPassword: "",
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }

    navigate(-1);
  };

  const handleSubmit = async (values) => {
    console.log("values", values);
    handleLoading(true);
    const payload = {
      emailOrPhone: values.emailOrPhone,
      newPassword: values?.password,
    };
    console.log("payload", payload);
    try {
      const res = await AuthApi?.resetPassword(payload);
      console.log("res", res);
      toast.success("Password reset successfully");
      navigate("/");
      handleLoading(false);
    } catch (error) {
      console.log("error", error);
      handleLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
      <div className="bg-white rounded-md w-[40%]">
        <Formik
          initialValues={initialValues}
          validationSchema={passwordValidationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ handleChange, values }) => (
            <Form className=" p-5">
              <h2 className="flex justify-between text-gray-800 font-semibold mb-4 border-b pb-2">
                <span >Change Password</span>
              <span onClick={handleClose}><IoMdClose/></span>
              </h2>
              <div className="items-center mb-3">
                <Lable lable="Email" />
                <div>
                  <TextInput
                    name="emailOrPhone"
                    type="text"
                    placeholder="E-mail"
                    value={values.emailOrPhone || ""}
                    disabled={true}
                  />
                  <ErrorMessage
                    name="emailOrPhone"
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <div className="items-center mb-3">
                <Lable lable="New Password" />
                <div>
                  <PasswordInput
                    name="password"
                    type="password"
                    placeholder="New Password"
                    onChange={handleChange}
                    value={values.password}
                    autoComplete
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error"
                  />
                </div>
              </div>

              <div className="items-center mb-3">
                <Lable lable="Confirm Password" />
                <div>
                  <PasswordInput
                    name="confirmPassword"
                    type="confirmPassword"
                    placeholder="Confirm Password"
                    onChange={handleChange}
                    value={values.confirmPassword}
                    autoComplete
                  />
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="error"
                  />
                </div>
              </div>

              <div className="mt-8 flex gap-4 justify-center flex-wrap">
                <Button text="Cancel" type="button" onClick={handleClose} />
                <Button text={"Update Password"} type={"submit"} />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePassword;
